import { Flex, Text } from '@chakra-ui/core'
import LocaleText from 'components/LocaleText'
import { ControlledSwitch } from 'components/ui/ControlledSwitch'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

interface Props {
  title?: string
  name: string
  size?: 'sm' | 'md'
  defaultValue?: boolean
  isDisabled?: boolean
}

export const PopSwitch = ({ title, name, size = 'sm', defaultValue = false, isDisabled = false }: Props) => {
  const { control, setValue } = useFormContext()
  return (
    <Flex w="max-content" alignItems="center" style={{ columnGap: '10px' }}>
      <Text fontSize="14px" fontWeight="bold" color="gray.500">
        {title && <LocaleText text={title} isLocalUse />}
      </Text>
      <Controller
        as={ControlledSwitch}
        name={name}
        control={control}
        defaultValue={defaultValue}
        valueName="isChecked"
        size={size}
        isDisabled={isDisabled}
        onChange={([event]) => {
          const newValue = event.target.checked
          setValue(name, newValue)
          return newValue
        }}
      />
    </Flex>
  )
}
